import { parse } from "yaml";

const YAML_SEP_REGEX = /^(-{3}|\+{3}|\.{3})$/;

export function parseFrontMatter(contents: string): {
  frontMatter: Record<string, unknown> | null;
  restOfContents: string;
} {
  const lines = contents.split("\n");
  const separator = lines?.[0].match(YAML_SEP_REGEX)?.[0];

  const yamlLines: string[] = [];
  let restOfContents: string = contents;

  if (lines != null && separator != null && lines.includes(separator, 1)) {
    for (let i = 1; i < lines.length; i++) {
      const line = lines[i];
      if (line === separator) {
        restOfContents = lines.slice(i + 1).join("\n");
        break;
      } else {
        yamlLines.push(line);
      }
    }
  }

  return {
    frontMatter: yamlLines.length > 0 ? parse(yamlLines.join("\n")) : null,
    restOfContents,
  };
}
